const VALIDATORS = {
  required: {
    func: (v) => v && v.length,
    text: "is required",
  },
  isUrl: {
    func: (v) => {
      try {
        const url = new URL(v);
        return url.protocol === "http:" || url.protocol === "https:";
      } catch (err) {
        return false;
      }
    },
    text: "needs to be a valid url and start with http:// or https://",
  },
  startsWithHashtag: {
    func: (v) => v && v[0] === "#",
    text: "needs to start with a hashtag (#)",
  },
};

export const TARGETS_TYPES = [
  {
    targetType: "slack",
    display: "Slack",
    icon: "fab fa-slack",
    infoFieldKey: "channel",
    options: {},
    fields: [
      {
        label: "Webhook Url",
        key: "webhookUrl",
        validations: [VALIDATORS.required, VALIDATORS.isUrl],
      },
      {
        label: "Channel",
        key: "channel",
        validations: [VALIDATORS.required, VALIDATORS.startsWithHashtag],
      },
    ],
  },
  {
    targetType: "whatsapp",
    display: "WhatsApp",
    icon: "fab fa-whatsapp",
    infoFieldKey: "phoneNumber",
    options: {},
    fields: [
      {
        label: "Phone Number",
        key: "phoneNumber",
        validations: [VALIDATORS.required],
      },
    ],
  },
  {
    targetType: "ifttt",
    display: "IFTTT",
    infoFieldKey: "eventName",
    options: {},
    fields: [
      {
        label: "Webhook Key",
        key: "webhookKey",
        validations: [VALIDATORS.required],
      },
      {
        label: "Event Name",
        key: "eventName",
        validations: [VALIDATORS.required],
      },
    ],
  },
];
